export default __webpack_public_path__ + "static/media/moments-preview.58c86d70.png";